import { createHandlerChainRunner, HandlerProps } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    orderNumber?: string;
    key: string;
    show: boolean;
}

interface Props {}

const DispatchShowHideModal = (props: HandlerProps<Parameter, Props>) => {
    props.dispatch({
        type: "Custom/Modals/SetModalVisibility",
        orderNumber: props.parameter.orderNumber,
        key: props.parameter.key,
        value: props.parameter.show,
    } as any);
};

export const chain = [DispatchShowHideModal];

const showHideCustomReusableModal = createHandlerChainRunner(chain, "ShowHideCustomReusableModal");
export default showHideCustomReusableModal;
